import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueRouter from 'vue-router'
import router from "./plugins/router"
import axios from 'axios'
import '@mdi/font/css/materialdesignicons.css';

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.use(VueRouter)

new Vue({
  icons: {
    iconfont: 'mdi', // 'mdiSvg' || 'mdiSvg' || 'mdi' || 'md' ||'fa' || 'fa4' || 'faSvg'
  },
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app')
